export default __webpack_public_path__ + "static/media/Corsairs-treasure-08.70ae01c1.png";